<template>
  <div class="login-center" v-if="isLogin">
    <div class="account-info">
      <div class="role-info">
        <img
          v-if="showIcon && userAvatar"
          class="role-info-ico"
          :src="userAvatar"
          alt="role-icon"
        />
        <div class="role-info-text">
          <div class="account">{{ userName }}</div>
          <div class="role" v-if="roleName">{{ roleName }}</div>
        </div>
      </div>
      <div
        v-if="isHome && showSwicthBtn"
        class="role-switch btn-wrap j-role-switch"
        @click="handleShowSelectRolePopup"
      >
        <span class="role-switch-text">{{ letter.voucherSwitchRole }}</span>
      </div>
      <div
        v-else-if="!isInWebview && showSwicthBtn"
        class="role-switch btn-wrap"
        @click="handleGoLogOut"
      >
        <span class="role-switch-text"> {{ letter.logout }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import login from '@mixins/officialTopup/login';
import { GET_BALANCE_USER_DATA_OF_OPEN } from '@store/officialTopup/coins';
import { mapGetters, mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
export default {
  name: 'LoginInfo',
  props: {
    showSwicthBtn: {
      default: false
    },
    showIcon: {
      default: false
    }
  },
  mixins: [login],
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    userName() {
      // 20240725 需求人: 邓智轩 特殊处理：顽星域名账号展示隐藏前缀 以DISPLAY_NAME字段作为账号显示名称
      if (globalConfig.getMainHost() === 'playplanetgame.com') {
        return this.displayName;
      } else {
        return this.loginAccount;
      }
    },
    isHome() {
      return this.$route.name == 'home';
    },
    userAvatar() {
      return this.picList?.avatar;
    },
    ...mapState({
      loginAccount: state => state.login.loginAccount,
      displayName: state => state.login.displayName,
      showCoinEntry: state => state.coins.showCoinEntry,
      isInWebview: state => state.isInWebview,
      picList: state => state.page.picList
    }),
    ...mapGetters(['getCoinsName'])
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.$store.dispatch(GET_BALANCE_USER_DATA_OF_OPEN);
      }
    }
  },
  methods: {
    handleShowSelectRolePopup() {
      this.showSelectRolePopup();
      clickButton({
        btnName: 'select_role',
        locationKey: locationType.accountInfo
      });
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.goLogOut();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
.login-center {
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: $moduleBackgroundColor;

  .account-info {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 31px 22px;
    font-size: 22px;
    color: #333333;
    .role-info {
      display: flex;
      align-items: center;
      &-ico {
        margin-right: 10px;
        width: 44px;
        height: 44px;
      }
      &-text {
        font-size: 26px;

        .account,
        .role {
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 25px;
        }
        .account {
          color: #999999;
          font-size: 22px;
        }
      }
    }
  }
  .btn-wrap {
    font-size: 24px;
    padding: 14px 20px;
    flex-shrink: 0;
    background-color: #ffffff;
    border-radius: 9px;
    border: solid 1px #efefef;
    box-sizing: border-box;
    cursor: pointer;
  }
}

@media screen and (orientation: landscape) {
  .login-center {
    position: relative;
    max-width: 1200px;
    margin-top: 21px;
    border-radius: 20px;

    .account-info {
      width: 100%;
      padding: 20px 40px;
      align-items: center;
      .btn-wrap {
        font-size: 20px;
      }
      .role-info {
        &-text {
          font-size: 20px;
          margin-left: 20px;
        }
        &-ico {
          width: 36px;
          height: 36px;
          color: #333333;
        }
        .account {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
